module.exports = __webpack_public_path__ + "img/offers7.42be9741.jpg";